<template>
  <div class="login-page">
    <div class="form-content">
      <h2 class="page-title">登入帳號</h2>
      <div class="form-card">
        <div class="two-columns">
          <div class="form-group">
            <span class="error-msg">{{ err_msg }}</span>
            <label for="username">帳號</label>
            <input id="username" type="text" v-model="username" placeholder="輸入帳號" :class="{ 'input-error': hasError }"
              required />
          </div>
          <div class="form-group">
            <div class="passwd-label-div">
              <label for="password">密碼</label>
              <router-link class="forgot-password-link" to="/reset-password">忘記密碼</router-link>
            </div>
            <input id="password" type="password" v-model="password" placeholder="輸入您的密碼"
              :class="{ 'input-error': hasError }" required />
          </div>
          <button type="submit" @click="attemptLogin">登入</button>
        </div> <!-- two-columns -->
      </div>
      <p class="register-link">還沒有帳號？<router-link to="/UserRegister">註冊帳號</router-link></p>
    </div>
    <ContactFooter />
    <div v-if="isLoading" >
      <LoadingSpinner loadingText="帳號登入中..." />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ContactFooter from '@/components/ContactFooter.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default {
  name: 'LoginPage',
  components: {
    ContactFooter,
    LoadingSpinner
  },
  data() {
    return {
      username: '',
      password: '',
      err_msg: '',
      isLoading: false
    };
  },
  computed: {
    ...mapState(['loginError']), // Map loginError from Vuex store

    hasError() {
      console.log('hasError:', this.err_msg);
      console.log(this.err_msg !== '');
      return this.err_msg !== '';
    }
  },
  methods: {
    ...mapActions(['login']), // Map login action from Vuex store

    async attemptLogin() {
      try {
        this.err_msg = '';

        //simulate api delay
        this.isLoading = true;

        // await new Promise(resolve => setTimeout(resolve, 10000));

        await this.login({ username: this.username, password: this.password }); // Calls Vuex action

        if (this.loginError) {
          console.log('登入失敗:', this.loginError);
          // alert('登入失敗:' + this.loginError);
          this.err_msg = '帳號或密碼有誤，請重新輸入'
          this.isLoading = false;
          return;
        }
        console.log('登入成功');
        this.$router.push('/'); // Redirect to dashboard on success
      } catch (error) {
        console.error('登入失敗:', error);
        this.err_msg = '帳號或密碼有誤，請重新輸入'
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
/* General Styles */
/* @import '@/css/modal.css'; */

/* Conditional error class */


/*  */

/* 主標題樣式 */
.page-title {
  margin-bottom: 0px;
  margin-top: 60px;

  /* //styleName: 6xl/bold; */
  font-family: Inter;
  font-size: 48px;
  font-weight: 700;
  line-height: 64.32px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

}




/* 表單容器樣式 */
.form-content {

  width: 946px;

  margin: 0 auto;
  /* padding: 20px; */
  /* background-color: red; */
  border-radius: 8px;
  font-size: 1.2rem;


}


.sub-title {
  /* //styleName: 3xl/bold; */
  font-family: Inter;
  font-size: 28px;
  font-weight: 700;
  line-height: 38.08px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;


  color: var(--gray15);
  margin: 0px;

}

/* 表單卡片樣式 */
.form-card {
  padding: 48px;
  padding-top: 16px;
  margin-bottom: 20px;
  background-color: white;
  border-radius: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  display: flex;
  flex-direction: column;
  gap: 32px;

  box-sizing: border-box;

}


.error-msg {
  /* //styleName: md/bold; */
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  height: 24px;
  color: var(--red02);
}


.two-columns {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 32px;
}

/* 表單組樣式 */
.form-group {
  /* margin-bottom: 20px; */
  margin: 0px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  margin-left: 0.2rem;
  /* color: #000; */
  /* 標籤文字顏色設為黑色 */
  font-weight: bold;
  text-align: left;

  /* //styleName: md/bold; */
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray13);


}

/* 表單輸入元素樣式 */
.form-group input[type="text"],
input[type="tel"],
input[type="email"],
input[type="date"],
input[type="password"],
select,
textarea {
  /* padding: 0.8rem; */
  padding-left: 12.5px;

  /* 默認灰色邊框 */

  outline: none;
  /* 去除默認的聚焦外邊框 */
  box-shadow: none;
  /* 去除默認的聚焦陰影 */
  background-color: white;
  /* 保持背景白色 */

  width: 408px;
  height: 64px;
  gap: 0px;
  border-radius: 12px;
  /* border: 1px; */
  /* opacity: 0px; */
  border: 1.5px solid var(--gray11);
  /* border: 1px solid white; */

  /* //styleName: md/bold; */
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray15);

  box-sizing: border-box;

  background-color: white;

}


/* 保持 select 的額外樣式 */
.form-select {

  color: var(--gray15);

  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  /* 默認灰色邊框 */
}



.form-submit-btn {
  /* width:100px; */

  background-color: var(--green03);
  color: white;
  border: none;


  cursor: pointer;
  display: block;
  margin: 0 auto;

  /* //styleName: xl/bold; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;




  padding: 24px 40px 24px 40px;
  border-radius: 99px;

  margin-top: 40px;
  margin-bottom: 160px;



}



.input-error {
  border-color: red !important;

  color: red;

  background-color: red;
}


/* 針對螢幕寬度小於 560px */
@media (max-width: 560px) {
  .form-content {
    max-width: 343px;
    /* 設定寬度為 343px */
    margin: 0 auto;
    /* 確保表單居中 */
    /* padding: 15px; */
    /* 調整內邊距 */
  }

  .page-title {
    margin-top: 45px;
  }



  .title-description {
    /* //styleName: sm/regular; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 21.56px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }

  .form-card {
    padding: 16px;
    /* 調整內邊距 */
    gap: 20px;
    margin: 0px auto;
  }

  .two-columns {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 16px;
  }

  .sub-title {
    /* //styleName: lg/bold; */
    font-family: Inter;
    font-size: 18px;
    font-weight: 700;
    line-height: 26.1px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

  }

  .form-group label {

    /* //styleName: sm/bold; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    /* 調整字體大小 */
  }

  .form-group input[type="text"],
  input[type="text"],
  input[type="tel"],
  input[type="email"],
  input[type="password"],


  textarea,
  .form-select {
    width: 311px;
    height: 48px;


    /* //styleName: sm/bold; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    box-sizing: border-box;
    /* background-color: red; */

  }

  .equipment-buttons {
    grid-template-columns: repeat(1, 1fr);
    /* 設定為單列 */
  }

  /* 調整設備按鈕的填充 */
  .equipment-button {

    width: 311px;
    height: 48px;

    /* //styleName: sm/bold; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    /* text-align: center;
      text-underline-position: from-font;
      text-decoration-skip-ink: none; */

  }

  .equipment-button .checkmark {
    position: absolute;
    top: 10px;
    left: 20px;
    font-size: 1.5rem;
    /* color: #008000; */
    /* 綠色對勾 */
  }

  .form-submit-btn {
    padding: 16px 32px 16px 32px;

    /* //styleName: lg/bold; */
    font-family: Inter;
    font-size: 18px;
    font-weight: 700;
    line-height: 26.1px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    margin-top: 20px;
    margin-bottom: 80px;

  }


}






/* ------------------------ */




.login-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--background-gray);
  /* padding: 40px 20px; */
  width: 100%;
}

.form-content {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;

  min-height: 70vh;
}

.form-card {
  margin-bottom: 40px;

  /* padding-top: 0px; */
  padding-bottom: 0px;
  box-shadow: none;

  background-color: transparent;
}

.passwd-label-div {
  display: flex;
  justify-content: space-between;
}

.forgot-password-link {
  display: block;
  text-align: right;
  color: var(--green03);
  margin-top: 5px;
  /* margin-bottom: 10px; */

  /* font-family: Inter; */
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: right;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

}

button {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 25px;
  background-color: var(--green03);
  color: white;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 20px;
}

button:hover {
  background-color: #005700;
}

.register-link {
  margin-top: 0px;
  /* font-size: 0.9rem; */
  color: #666;

  /* font-family: Inter; */
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  /* text-decoration-line: underline; */
  text-decoration-style: solid;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  /* margin-bottom: 100px; */

}

.register-link a {
  color: var(--green03);
  font-weight: bold;
  text-decoration: none;
  text-decoration-line: underline;
}


@media screen and (max-width: 560px) {
  .form-content {
    /* padding: 20px; */
    padding: 0px;
    width: 344px;
  }


  .page-title {
    /* //styleName: 4xl/bold; */
    font-family: Inter;
    font-size: 32px;
    font-weight: 700;
    line-height: 43.52px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    margin-bottom: 8px;

  }

  .error-msg {
    /* //styleName: sm/bold; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;


    height: 14px;
  }

  .form-card {
    padding: 15px;

    width: 343px;
    margin-bottom: 10px;
    /* background-color: red; */
  }

  .forgot-password-link {
    font-size: 14px;
    margin-top: 2px;
  }

  button {
    padding: 10px;

    /* //styleName: md/bold; */
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

  }

  .register-link {
    font-size: 14px;
    font-weight: 700;
    line-height: 21px;
    /* text-align: right; */

  }

}

.loading-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  z-index: 1001;
}

.spinner {
  
  /* position: relative; */

  margin-top:250px;

  border: 16px solid #f3f3f3;
  border-top: 14px solid var(--green01);

  /* color: var(--green03); */
  /* color: red; */
  border-radius: 50%;
  width: 100px;
  height: 100px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


@media screen and (max-width: 560px) {
  .spinner {
    margin-top: 200px;

    width: 50px;
    height: 50px;

    border-width: 8px;
  }
  
}
</style>
